import { JsonObject, JsonProperty } from 'json2typescript';
import { Lot } from './lot-model';
import { PoItem } from './po-item-model';

@JsonObject('PoItemWithLot')
export class PoItemWithLot extends PoItem {
  @JsonProperty('lot', Lot, true) lot: Lot = undefined;
}
